module.exports = __webpack_public_path__ + "static/media/hashtag.9a5f2f33.svg";